/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import _ from 'underscore';

/* eslint-disable import/no-unresolved,import/extensions */
import { define } from '@bingads-webui-campaign-react/ui-next/src/legacy-dep-bootstrap/shim/requirejs-amd';
import componentConfigImport from '@bingads-webui-component-legacy/config/index';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { requireWithPromisify } from '@bingads-webui-universal/require-promisify';
/* eslint-enable */

const pageContext = PageContext;
const config = componentConfigImport;

/* eslint-disable */

  /*
  * This file is also used to generate the context.config.js,
  * please DON'T put anything before the "require.config({" line
  * which may confuse the generator.
  *
  * Refer to the Gruntfile.js under tools/grunt-tasks for detail
  */
if (__non_webpack_require__ && __non_webpack_require__.config) {
  __non_webpack_require__.config({
    paths: {
      // - shorthand
      '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      '$/data': '@bingads-webui-component-legacy/requirejs-data/index',
      '$/tmpl': '@bingads-webui-static-legacy/extension/requirejs/tmpl',
      '$/domready': '@bingads-webui-static-legacy/extension/requirejs/domready',
      // -
      'lib/kendo/kendo.autocomplete': 'module/shim/kendo/kendo.autocomplete',
      'lib/kendo/kendo.calendar': 'module/shim/kendo/kendo.calendar',
      'lib/kendo/kendo.colorpicker': 'module/shim/kendo/kendo.colorpicker',
      'lib/kendo/kendo.core': 'module/shim/kendo/kendo.core',
      'lib/kendo/kendo.data': 'module/shim/kendo/kendo.data',
      'lib/kendo/kendo.data.odata': 'module/shim/kendo/kendo.data.odata',
      'lib/kendo/kendo.datepicker': 'module/shim/kendo/kendo.datepicker',
      'lib/kendo/kendo.draganddrop': 'module/shim/kendo/kendo.draganddrop',
      'lib/kendo/kendo.list': 'module/shim/kendo/kendo.list',
      'lib/kendo/kendo.listview': 'module/shim/kendo/kendo.listview',
      'lib/kendo/kendo.multiselect': 'module/shim/kendo/kendo.multiselect',
      'lib/kendo/kendo.popup': 'module/shim/kendo/kendo.popup',
      'lib/kendo/kendo.selectable': 'module/shim/kendo/kendo.selectable',
      'lib/kendo/kendo.slider': 'module/shim/kendo/kendo.slider',
      'lib/kendo/kendo.sortable': 'module/shim/kendo/kendo.sortable',
      'lib/kendo/kendo.timepicker': 'module/shim/kendo/kendo.timepicker',
      'lib/kendo/kendo.treeview': 'module/shim/kendo/kendo.treeview',
      'lib/kendo/kendo.userevents': 'module/shim/kendo/kendo.userevents',
      'lib/kendo/kendo.window': 'module/shim/kendo/kendo.window',
      // schema mapping
      '$/schema': '@bingads-webui-component-legacy/schema-proxy/loader',
      '$/schema-raw': '@bingads-webui-component-legacy/schema-proxy/raw-loader',
      '$/schemas': '@bingads-webui-component-legacy/schema-proxy/schema-set-loader',
      '$/processed-schema': '@bingads-webui-component-legacy/schema-campaign-json/schema-load-plugin',
      // when you change the path of schemas, you MUST also change the corresponding 'map' in context.js
      // '@bingads-webui-component-legacy/schema-campaign/override'    : '@bingads-webui-component-legacy/schema-campaign/override',
      // '@bingads-webui-component-legacy/schema-campaign'             : '@bingads-webui-component-legacy/schema-campaign/2015-10-21',
      // top level
      config: 'module/app/config',
      // css
      '$/css': '@bingads-webui-component-legacy/cssloader/index',
      '$/config': '@bingads-webui-component-legacy/config/loader',
      '$/schema-i18n': '@bingads-webui-component-legacy/schema-i18n/loader',
    },
    map: {
      lib: {
        'bluebird': 'bluebird',
        'cldrjs': 'cldrjs',
        'globalize': 'globalize',
        'js-data': 'js-data',
        'js-data-schema': 'js-data-schema',
        'underscore': 'underscore',
      },
      'component/js-data-extension': {
        'lib/js-data': 'js-data',
      },
      'component': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'component/github': {
        'underscore': 'underscore',
        'backbone': 'backbone',
        'bluebird': 'bluebird',
        'knockout': 'knockout',
        'fast-binary-indexed-tree': '@bingads-webui-component-legacy/github/node_modules/fast-binary-indexed-tree/dist/fast-binary-indexed-tree',
        'backbone-virtualized-listview': '@bingads-webui-component-legacy/github/node_modules/backbone-virtualized-listview/dist/backbone-virtualized-listview',
      },
      'SearchTerm2Keyword': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'module/view': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
        'styles': '../../../Styles',
      },
      'module/model/audiences': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'module/viewmodel': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'template/bulkEdit': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'module/view/bulkEdit/bulkEditJob':{
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'module/service/error':{
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'module/view/bulkUpload': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
        'styles': '../../../../Styles',
      },
      'module/view/dashboard': {
        'styles': '../../../../Styles',
      },
      'module/viewmodel/bulkUpload': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/audience': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/adgroup-bulk-edit': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/adgroup-create-advanced': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/adgroup-settings': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/advanced-settings': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/alerts-popup': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/bidding-strategy': {
        '$/i18n': '@bingads-webui-static-legacy/extension/requirejs/i18n',
      },
      'campaignui/feature/bingadsgrid': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/campaign-bulk-edit': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/campaign-create-advanced': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/campaign-settings': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/common': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/common-grid-config': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/common-grid-plugins': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/copy-paste': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/crud-ad': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/crud-adgroup': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/crud-campaign': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/crud-keywords': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/griddownload': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/inline-chart': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/label': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/location-targets': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/shared-budget': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/shopping-campaign': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/targeting-settings': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/performance-targets': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/accounts-summary': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'campaignui/feature/ad-groups-tab': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      'component/api-errors-campaign': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
      },
      '@bingads-webui': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
        'axe-core': 'lib/axe-core',
        'axe-core/axe': 'lib/axe-core',
        'backbone': 'backbone',
        'backbone-toolbar': '@bingads-webui-component-legacy/github/node_modules/backbone-toolbar/dist/backbone-toolbar',
        'bluebird': 'bluebird',
        'cron-parser': 'cron-parser',
        'iana-tz-data': 'iana-tz-data',
        'js-cookie': 'lib/js-cookie',
        'knockout': 'knockout',
        'path-browserify': 'lib/path-browserify',
        'projection-grid': '@bingads-webui-component-legacy/github/node_modules/projection-grid/dist/projection-grid',
        'underscore': 'underscore',
        'underscore.string': 'underscore.string',
        'pagination-control': '@bingads-webui-component-legacy/github/node_modules/pagination-control/dist/pagination-control',
        'js-data': 'js-data',
        'js-data-schema': 'js-data-schema',
        'js-data-localstorage': 'js-data-localstorage',
      },
      '@bingads-webui-universal': {
        'underscore.string': 'underscore.string',
        'js-data': '@bingads-webui-component-legacy/js-data-extension/index',
      },
      '@bingads-webui-campaign': {
        'js-data': 'js-data',
        'underscore.string': 'underscore.string',
      },
      '@bingads-webui-campaign-react': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
        'underscore.string': 'underscore.string',
        'papaparse': 'papaparse',
      },
      '@bingads-webui-react': {
        'underscore.string': 'underscore.string',
      },
      '*': {
        '$/i18n': '@bingads-webui-component-legacy/i18n/loader',
        '$/domready': '@bingads-webui-static-legacy/extension/requirejs/domready',
        '$/schema': '$/processed-schema',
        'component/http/channel/odata': '@bingads-webui-component-legacy/http/channel/odata',
        'component/preference/service/index': '@bingads-webui-component-legacy/preference/service/index',
        'component/legacy-router/index': '@bingads-webui-component-legacy/legacy-router/index',
        'component/config/index': '@bingads-webui-component-legacy/config/index',
        'component/state/index': '@bingads-webui-component-legacy/state/index',
        'component/js-data-storage/session-storage': '@bingads-webui-component-legacy/js-data-storage/session-storage',
        'SummaryDataContextManager': '@bingads-webui-static-legacy/summary/SummaryDataContextManager',
        'campaignui/feature/cache-manager/index': '@bingads-webui-campaign-legacy/cache-manager/index',
        '@bingads-webui/azure-upload': '@bingads-webui/azure-upload',
        '@bingads-webui-campaign/campaign-cache-manager': '@bingads-webui-campaign/campaign-cache-manager',
        '@aria/webjs-sdk': '@aria/webjs-sdk',
        '@bingads-webui/aria-web-telemetry/aria-web-telemetry-2.8.0': '@bingads-webui/aria-web-telemetry/aria-web-telemetry-2.8.0',
        '@bingads-webui/azure-storage-blob': '@bingads-webui/azure-storage-blob',
        '@bingads-webui/kendo': '@bingads-webui/kendo', // moved from path section
        '@bingads-webui/primitive-utilities': '@bingads-webui-universal/primitive-utilities',
        "@emotion/is-prop-valid": "@emotion/is-prop-valid",
        "@emotion/memoize": "@emotion/memoize",
        'LocalStorage': '@bingads-webui-component-legacy/storage/localStorage',
        'MemoryStorage': '@bingads-webui-component-legacy/storage/memoryStorage',
        'SessionStorage': '@bingads-webui-component-legacy/storage/sessionStorage',
        'StateManager/CampaignStateManager': '@bingads-webui-component-legacy/statemanager/campaignStateManager',
        'babel-polyfill': 'babel-polyfill',
        'backbone': 'backbone',
        'backbone-virtualized-listview': '@bingads-webui-component-legacy/github/node_modules/backbone-virtualized-listview/dist/backbone-virtualized-listview',
        'bluebird': 'bluebird',
        'bootstrap': 'bootstrap',
        'brcast': 'brcast',
        'classnames': 'classnames',
        'cldrjs': 'cldrjs',
        'campaignui/feature/advanced-settings/util/exclusion-repository': '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository',
        'component/js-data-campaign/index': '@bingads-webui-component-legacy/js-data-campaign/index',
        'component/edm-campaign/index': '@bingads-webui-component-legacy/edm-campaign/index',
        'component/edm-campaign/index-new': '@bingads-webui-component-legacy/edm-campaign/index',
        'component/event-dispatcher/index': '@bingads-webui-component-legacy/event-dispatcher/index',
        'campaignui/feature/hotel-center-js-data/index': '@bingads-webui-campaign-legacy/hotel-center-js-data/index',
        'campaignui/feature/hotel-center-edm/index': '@bingads-webui-campaign-legacy/hotel-center-edm/index',
        'component/schema-campaign-json/override/$metadata': '@bingads-webui-component-legacy/schema-campaign/override/$metadata',
        'component/schema-campaign-json/schemas/$metadata': '@bingads-webui-component-legacy/schema-campaign/schemas/$metadata',
        'create-react-context': 'create-react-context',
        'cropperjs': 'cropperjs',
        "css-jss": "css-jss",
        'css-vendor': 'css-vendor',
        'decode-uri-component': 'decode-uri-component',
        'dom-helpers': 'dom-helpers',
        'exenv': 'exenv',
        'ext/google/gsi': 'https://accounts.google.com/gsi/client',
        'fast-binary-indexed-tree': '@bingads-webui-component-legacy/github/node_modules/fast-binary-indexed-tree/dist/fast-binary-indexed-tree',
        'globalize': 'globalize',
        'highcharts': 'highcharts',
        'history': 'history',
        'hoist-non-react-statics': 'hoist-non-react-statics',
        'hyphenate-style-name': 'hyphenate-style-name',
        'iana-tz-data': 'iana-tz-data',
        'immutable': 'immutable',
        'invariant': 'invariant',
        'is-function': 'is-function',
        'is-in-browser': 'is-in-browser',
        'is-plain-object': 'is-plain-object',
        'isarray': 'isarray',
        'isobject': 'isobject',
        'jquery': 'jquery',
        'jquery-jcrop': 'jquery-jcrop',
        'json': 'json',
        'json-stable-stringify': 'json-stable-stringify',
        'jsonify': 'jsonify',
        'jss': 'jss',
        'jss-camel-case': 'jss-camel-case',
        'jss-compose': 'jss-compose',
        'jss-default-unit': 'jss-default-unit',
        'jss-expand': 'jss-expand',
        'jss-extend': 'jss-extend',
        'jss-global': 'jss-global',
        'jss-nested': 'jss-nested',
        'jss-preset-default': 'jss-preset-default',
        'jss-props-sort': 'jss-props-sort',
        'jss-template': 'jss-template',
        'jss-vendor-prefixer': 'jss-vendor-prefixer',
        "jss-plugin-camel-case": "jss-plugin-camel-case",
        "jss-plugin-compose": "jss-plugin-compose",
        "jss-plugin-default-unit": "jss-plugin-default-unit",
        "jss-plugin-expand": "jss-plugin-expand",
        "jss-plugin-extend": "jss-plugin-extend",
        "jss-plugin-global": "jss-plugin-global",
        "jss-plugin-nested": "jss-plugin-nested",
        "jss-plugin-props-sort": "jss-plugin-props-sort",
        "jss-plugin-rule-value-function": "jss-plugin-rule-value-function",
        "jss-plugin-rule-value-observable":"jss-plugin-rule-value-observable",
        "jss-plugin-template": "jss-plugin-template",
        "jss-plugin-vendor-prefixer": "jss-plugin-vendor-prefixer",
        'kendo': '@bingads-webui/kendo',
        'keycode': 'keycode',
        'knockout': 'knockout', // some modules imports knockout instead of lib/knockout
        'lib/backbone/backbone': 'backbone',
        'lib/js-data': '@bingads-webui-component-legacy/js-data-extension/index',
        'lib/koLoader': 'lib/int/requirejs/ko',
        'lib/underscore/underscore': 'underscore',
        'minigrid': 'minigrid',
        'object-assign': 'object-assign',
        'odata-v4-filter-parser': 'odata-v4-filter-parser',
        'office-ui-fabric-react': 'office-ui-fabric-react',
        'pagination-control': '@bingads-webui-component-legacy/github/node_modules/pagination-control/dist/pagination-control',
        'path-to-regexp': 'path-to-regexp',
        'popper.js': 'popper.js',
        'process': 'process',
        'projection-grid': '@bingads-webui-component-legacy/github/node_modules/projection-grid/dist/projection-grid',
        'prop-types': 'prop-types',
        'prop-types-extra': 'react-prop-types',
        'pug-runtime': 'pug-runtime',
        'query-string': 'query-string',
        'react': 'react',
        'react-bootstrap': 'react-bootstrap',
        "react-display-name": "react-display-name",
        'react-dom': 'react-dom',
        'react-is': 'react-is',
        'react-jss': 'react-jss',
        'react-lifecycles-compat': 'react-lifecycles-compat',
        'react-modal': 'react-modal',
        'react-onclickoutside': 'react-onclickoutside',
        'react-overlays': 'react-overlays',
        'react-popper': 'react-popper',
        'react-prop-types': 'react-prop-types', // rewrite deprecated react-prop-types to prop-types-extra
        'react-redux': 'react-redux',
        'react-router': 'react-router',
        'react-router-dom': 'react-router-dom',
        'react-textfit': 'react-textfit',
        'react-transition-group': 'react-transition-group',
        'react-virtualized': 'react-virtualized',
        'redux': 'redux',
        'redux-thunk': 'redux-thunk',
        'regenerator-runtime': 'regenerator-runtime',
        'requirejs': 'require',
        'reselect': 'reselect',
        'resolve-pathname': 'resolve-pathname',
        'scheduler': 'scheduler',
        "shallow-equal": "shallow-equal",
        'smart-truncate': 'smart-truncate',
        'stacktrace-js': 'stacktrace-js',
        'stacktrace-gps': 'stacktrace-gps',
        'stackframe': 'stackframe',
        'stack-generator': 'stack-generator',
        'error-stack-parser': 'error-stack-parser',
        'source-map':'source-map',
        'strict-uri-encode': 'strict-uri-encode',
        'symbol-observable': 'symbol-observable',
        'tc39-proposal-temporal': 'tc39-proposal-temporal',
        'text': 'text',
        'theming': 'theming',
        "tiny-warning": "tiny-warning",
        'uncontrollable': 'uncontrollable',
        'underscore': 'underscore',
        'urijs': 'urijs',
        'value-equal': 'value-equal',
        'warning': 'warning',
      },
    },
    shim: {
      // - lib
      'lib/underscore': {
        'exports': '_',
        'init': function () {
          _.templateSettings = {
            interpolate: /\{\{(.+?)\}\}/g,
          };
        },
      },
      'address': {
        'exports': 'jQuery.fn.address',
      },
      'jquery': {
        'exports': 'jQuery',
      },
    },
    'waitSeconds': 0,
    config: {
      '@bingads-webui/cldr-data-loader': {
        paths: {
          core: '@bingads-webui-universal/i18n-cldr-data-modern/core.json',
          locale: locale => `@bingads-webui-universal/i18n-cldr-data-modern/locales-simplified/${locale}.json`,
        },
      },
    },
  });
}

/* eslint-enable */
define('@bingads-webui-static-legacy/page-context', [], () => pageContext);
define('@bingads-webui-component-legacy/config/index', [], () => config);
define('PageContext', [], () => pageContext);
define('component/config/index', [], () => config);

// Seems like 3rd party scripts use these modules, so we'll require them and hope they load soon enough.
window.require([
  '@bingads-webui-static-legacy/page-context',
  '@bingads-webui-component-legacy/config/index',
  'PageContext',
  'component/config/index',
]);

/* Some library comments
=======
globalize complains about not receiving an instance of string or cldrjs. Shimming cldrjs as well
did not solve the issue. Needs additional investigation:
'globalize'
===================
jsdata in old UI uses bluebird, if we shim with webpack one it will return native promises
unless we shim in new UI too:
'lib/js-data
'js-data-localstorage'
'js-data-schema'
*/

const libs = {
  'lib/highcharts': () => import(/* webpackChunkName: "vendor.async.primary" */'highcharts'),
  'lib/react': () => import(/* webpackChunkName: "vendor.async.primary" */'react'),
  'lib/react-dom': () => import(/* webpackChunkName: "vendor.async.primary" */'react-dom'),
  'lib/react-router-dom': () => import(/* webpackChunkName: "vendor.async.primary" */'react-router-dom'),
  'lib/react-router': () => import(/* webpackChunkName: "vendor.async.primary" */'react-router'),
  'lib/knockout': () => import(/* webpackChunkName: "vendor.async.primary" */'knockout'),
  'lib/react-virtualized': () => import(/* webpackChunkName: "vendor.async.primary" */'react-virtualized'),
  'lib/react-is': () => import(/* webpackChunkName: "vendor.async.primary" */'react-is'),
  'lib/react-jss': () => import(/* webpackChunkName: "vendor.async.primary" */'react-jss'),
  'lib/react-lifecycles-compat': () => import(/* webpackChunkName: "vendor.async.primary" */'react-lifecycles-compat'),
  'lib/react-modal': () => import(/* webpackChunkName: "vendor.async.primary" */'react-modal'),
  'lib/react-onclickoutside': () => import(/* webpackChunkName: "vendor.async.primary" */'react-onclickoutside'),
  'lib/react-overlays': () => import(/* webpackChunkName: "vendor.async.primary" */'react-overlays'),
  'lib/react-popper': () => import(/* webpackChunkName: "vendor.async.primary" */'react-popper'),
  'lib/react-textfit': () => import(/* webpackChunkName: "vendor.async.primary" */'react-textfit'),
  'lib/react-transition-group': () => import(/* webpackChunkName: "vendor.async.primary" */'react-transition-group'),
  'lib/@aria/webjs-sdk': () => import(/* webpackChunkName: "vendor.async.primary" */'@aria/webjs-sdk'),
  'lib/backbone': () => Promise.all([
    import(/* webpackChunkName: "vendor.async.primary" */'backbone'),
    import(/* webpackChunkName: "vendor.async.primary" */'jquery'),
  ]).then(([Backbone, $]) => {
    // eslint-disable-next-line no-param-reassign
    Backbone.default.$ = $.default;
    return Backbone;
  }),
  'lib/bluebird': () => import(/* webpackChunkName: "vendor.async.primary" */'bluebird'),
  'lib/bootstrap': () => import(/* webpackChunkName: "vendor.async.primary" */'bootstrap'),
  'lib/classnames': () => import(/* webpackChunkName: "vendor.async.primary" */'classnames'),
  'lib/exenv': () => import(/* webpackChunkName: "vendor.async.primary" */'exenv'),
  'lib/history': () => import(/* webpackChunkName: "vendor.async.primary" */'history'),
  'lib/hoist-non-react-statics': () => import(/* webpackChunkName: "vendor.async.primary" */'hoist-non-react-statics'),
  'lib/invariant': () => import(/* webpackChunkName: "vendor.async.primary" */'invariant'),
  'lib/isarray': () => import(/* webpackChunkName: "vendor.async.primary" */'isarray'),
  'lib/js-cookie': () => import(/* webpackChunkName: "vendor.async.primary" */'js-cookie'),
  'lib/json-stable-stringify': () => import(/* webpackChunkName: "vendor.async.primary" */'json-stable-stringify'),
  'lib/jsonify': () => import(/* webpackChunkName: "vendor.async.primary" */'jsonify'),
  'lib/object-assign': () => import(/* webpackChunkName: "vendor.async.primary" */'object-assign'),
  'lib/scheduler': () => import(/* webpackChunkName: "vendor.async.primary" */'scheduler'),
  'lib/odata-v4-filter-parser': () => import(/* webpackChunkName: "vendor.async.primary" */'odata-v4-filter-parser'),
  'lib/path-browserify': () => import(/* webpackChunkName: "vendor.async.primary" */'path-browserify'),
  'lib/path-to-regexp': () => import(/* webpackChunkName: "vendor.async.primary" */'path-to-regexp'),
  'lib/prop-types': () => import(/* webpackChunkName: "vendor.async.primary" */'prop-types'),
  'lib/pug-runtime': () => import(/* webpackChunkName: "vendor.async.primary" */'pug-runtime'),
  'lib/resolve-pathname': () => import(/* webpackChunkName: "vendor.async.primary" */'resolve-pathname'),
  'lib/symbol-observable': () => import(/* webpackChunkName: "vendor.async.primary" */'symbol-observable'),
  'lib/stacktrace-js': () => import(/* webpackChunkName: "vendor.async.primary" */'stacktrace-js'),
  'lib/tc39-proposal-temporal': () => import(/* webpackChunkName: "vendor.async.primary" */'tc39-proposal-temporal'),
  'lib/underscore.string': () => import(/* webpackChunkName: "vendor.async.primary" */'underscore.string'),
  'lib/urijs': () => import(/* webpackChunkName: "vendor.async.primary" */'urijs'),
  'lib/value-equal': () => import(/* webpackChunkName: "vendor.async.primary" */'value-equal'),
  'lib/warning': () => import(/* webpackChunkName: "vendor.async.primary" */'warning'),
  'lib/jquery': () => import(/* webpackChunkName: "vendor.async.primary" */'jquery'),
  'lib/underscore': () => import(/* webpackChunkName: "vendor.async.primary" */'underscore'),
  '@bingads-webui-universal/i18n-cldr-data-modern/core.json': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui-universal/i18n-cldr-data-modern/core.json'),
  'lib/kendo/kendo.data': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui/kendo/kendo.data'),
  '@bingads-webui-campaign/injection-context': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui-campaign/injection-context'),
  'lib/@bingads-webui-universal/i18n-iana-tz-data': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui-universal/i18n-iana-tz-data/dist/i18n-iana-tz-data.json'),
  '@bingads-webui/campaign-odata-schemas': () => import(/* webpackMode: 'eager' */ '@bingads-webui/campaign-odata-schemas'),
  '@bingads-webui/odata-bulk-upsert-config': () => import(/* webpackMode: 'eager' */ '@bingads-webui/odata-bulk-upsert-config'),
  '@bingads-webui-campaign/campaign-ui-schemas': () => import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/campaign-ui-schemas'),
  'component/bingads-grid/service/column-chooser-preferences': () => import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences'),
  'component/bingads-grid/service/segmentation-preferences': () => import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences'),
  '@bingads-webui-universal/primitive-utilities': () => import(/* webpackMode: 'eager' */ '@bingads-webui-universal/primitive-utilities'),
  '@bingads-webui-campaign/feeds-core': () => import(/* webpackChunkName: "feeds-page" */'@bingads-webui-campaign/feeds-core'),
  'component/js-data-odata/index': () => import(/* webpackMode: 'eager' */'@bingads-webui-component-legacy/js-data-odata/index'),
  highcharts: () => import(/* webpackChunkName: "vendor.async.primary" */'highcharts'),
  react: () => import(/* webpackChunkName: "vendor.async.primary" */'react'),
  'react-dom': () => import(/* webpackChunkName: "vendor.async.primary" */'react-dom'),
  'react-router-dom': () => import(/* webpackChunkName: "vendor.async.primary" */'react-router-dom'),
  'react-router': () => import(/* webpackChunkName: "vendor.async.primary" */'react-router'),
  knockout: () => import(/* webpackChunkName: "vendor.async.primary" */'knockout'),
  'react-virtualized': () => import(/* webpackChunkName: "vendor.async.primary" */'react-virtualized'),
  'react-is': () => import(/* webpackChunkName: "vendor.async.primary" */'react-is'),
  'react-jss': () => import(/* webpackChunkName: "vendor.async.primary" */'react-jss'),
  'react-lifecycles-compat': () => import(/* webpackChunkName: "vendor.async.primary" */'react-lifecycles-compat'),
  'react-modal': () => import(/* webpackChunkName: "vendor.async.primary" */'react-modal'),
  'react-onclickoutside': () => import(/* webpackChunkName: "vendor.async.primary" */'react-onclickoutside'),
  'react-overlays': () => import(/* webpackChunkName: "vendor.async.primary" */'react-overlays'),
  'react-popper': () => import(/* webpackChunkName: "vendor.async.primary" */'react-popper'),
  'react-textfit': () => import(/* webpackChunkName: "vendor.async.primary" */'react-textfit'),
  'react-transition-group': () => import(/* webpackChunkName: "vendor.async.primary" */'react-transition-group'),
  '@aria/webjs-sdk': () => import(/* webpackChunkName: "vendor.async.primary" */'@aria/webjs-sdk'),
  backbone: () => Promise.all([
    import(/* webpackChunkName: "vendor.async.primary" */'backbone'),
    import(/* webpackChunkName: "vendor.async.primary" */'jquery'),
  ]).then(([Backbone, $]) => {
    // eslint-disable-next-line no-param-reassign
    Backbone.default.$ = $.default;
    return Backbone;
  }),
  bluebird: () => import(/* webpackChunkName: "vendor.async.primary" */'bluebird'),
  bootstrap: () => import(/* webpackChunkName: "vendor.async.primary" */'bootstrap'),
  classnames: () => import(/* webpackChunkName: "vendor.async.primary" */'classnames'),
  exenv: () => import(/* webpackChunkName: "vendor.async.primary" */'exenv'),
  history: () => import(/* webpackChunkName: "vendor.async.primary" */'history'),
  'hoist-non-react-statics': () => import(/* webpackChunkName: "vendor.async.primary" */'hoist-non-react-statics'),
  invariant: () => import(/* webpackChunkName: "vendor.async.primary" */'invariant'),
  isarray: () => import(/* webpackChunkName: "vendor.async.primary" */'isarray'),
  'js-cookie': () => import(/* webpackChunkName: "vendor.async.primary" */'js-cookie'),
  'json-stable-stringify': () => import(/* webpackChunkName: "vendor.async.primary" */'json-stable-stringify'),
  jsonify: () => import(/* webpackChunkName: "vendor.async.primary" */'jsonify'),
  'object-assign': () => import(/* webpackChunkName: "vendor.async.primary" */'object-assign'),
  scheduler: () => import(/* webpackChunkName: "vendor.async.primary" */'scheduler'),
  'odata-v4-filter-parser': () => import(/* webpackChunkName: "vendor.async.primary" */'odata-v4-filter-parser'),
  'path-browserify': () => import(/* webpackChunkName: "vendor.async.primary" */'path-browserify'),
  'path-to-regexp': () => import(/* webpackChunkName: "vendor.async.primary" */'path-to-regexp'),
  'prop-types': () => import(/* webpackChunkName: "vendor.async.primary" */'prop-types'),
  'pug-runtime': () => import(/* webpackChunkName: "vendor.async.primary" */'pug-runtime'),
  'resolve-pathname': () => import(/* webpackChunkName: "vendor.async.primary" */'resolve-pathname'),
  'symbol-observable': () => import(/* webpackChunkName: "vendor.async.primary" */'symbol-observable'),
  'stacktrace-js': () => import(/* webpackChunkName: "vendor.async.primary" */'stacktrace-js'),
  'tc39-proposal-temporal': () => import(/* webpackChunkName: "vendor.async.primary" */'tc39-proposal-temporal'),
  'underscore.string': () => import(/* webpackChunkName: "vendor.async.primary" */'underscore.string'),
  urijs: () => import(/* webpackChunkName: "vendor.async.primary" */'urijs'),
  'value-equal': () => import(/* webpackChunkName: "vendor.async.primary" */'value-equal'),
  warning: () => import(/* webpackChunkName: "vendor.async.primary" */'warning'),
  jquery: () => import(/* webpackChunkName: "vendor.async.primary" */'jquery'),
  underscore: () => import(/* webpackChunkName: "vendor.async.primary" */'underscore'),
  'kendo/kendo.data': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui/kendo/kendo.data'),
  '@bingads-webui-universal/i18n-iana-tz-data': () => import(/* webpackChunkName: "vendor.async.primary" */'@bingads-webui-universal/i18n-iana-tz-data/dist/i18n-iana-tz-data.json'),
  '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences': () => import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences'),
  '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences': () => import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences'),
  '@bingads-webui-component-legacy/js-data-odata/index': () => import(/* webpackMode: 'eager' */'@bingads-webui-component-legacy/js-data-odata/index'),
};

const skipDefaultLoad = {
  'lib/@aria/webjs-sdk': true,
  'lib/react-jss': true,
  'component/js-data-odata/index': true,
  '@aria/webjs-sdk': true,
  'react-jss': true,
  '@bingads-webui-component-legacy/js-data-odata/index': true,
};


window.performance.preAppStartLogs = [];

// Undefine these shimmed libraries from RJS if have already been defined.
// Should not be necessary if rjs bundles are properly configured, but a bit of safety measure.

const duplicateLibs = [];

Object.keys(libs).forEach((lib) => {
  if (window.require.s.contexts._.defined[lib]) {
    duplicateLibs.push(lib);
  }
  window.require.undef(lib);
});

if (duplicateLibs.length > 0) {
  window.performance.preAppStartLogs.push({ message: `Duplicate libraries found! ${duplicateLibs.join(',')}`, type: 'trace' });
}


// Shim the RJS load function to inject the webpack module.
// This gets called when RJS cannot find the module in any of its bundles.
const realLoadFn = window.require.load;
window.require.load = function loader(context, moduleName, url) {
  if (!moduleName || !libs[moduleName]) {
    realLoadFn(context, moduleName, url);
    return;
  }

  const libraryLoader = libs[moduleName];
  libraryLoader().then((libExports) => {
    const retVal = skipDefaultLoad[moduleName] || !libExports.default ? libExports : libExports.default;

    define(moduleName, [], () => retVal);
    context.completeLoad(moduleName);
  });
};

requireWithPromisify(window.require);
